import { render, staticRenderFns } from "./SpotlightArticle.vue?vue&type=template&id=6e29b326&scoped=true"
import script from "./SpotlightArticle.vue?vue&type=script&lang=js"
export * from "./SpotlightArticle.vue?vue&type=script&lang=js"
import style0 from "./SpotlightArticle.vue?vue&type=style&index=0&id=6e29b326&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e29b326",
  null
  
)

export default component.exports